import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { Platform } from "react-native";
import { logEvent } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyCN8wpMYmYvVyxe1wWGLeWPtvMq2WDAnMs",
  authDomain: "vb-trails.firebaseapp.com",
  projectId: "vb-trails",
  storageBucket: "vb-trails.firebasestorage.app",
  messagingSenderId: "782134635214",
  appId: "1:782134635214:web:368a3dbcb4a11f87fbfe9f",
  measurementId: "G-HXEYB6MWYF",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const logAnalyticsEvent = (name, params) => {
  // Initialize Analytics only on the web platform
  let analytics;
  if (process.env.NODE_ENV === "production") {
    if (Platform.OS === "web") {
      analytics = getAnalytics(app);
      if (analytics) {
        logEvent(analytics, name, params);
      }
    }
  }
};

export { app, logAnalyticsEvent };
